import type { QueryClient } from '@tanstack/react-query';

/**
 * After an AP or bank document is captured or posted, every dependent read is stale: the invoice,
 * credit-note, payment and movement lists and details, the supplier's outstanding payable and the
 * bank balances. They are re-read at once, including those on pages not open now, so a page opened
 * next shows the new outstanding or balance rather than the one cached before the posting.
 */
export async function refreshAfterPosting(queryClient: QueryClient): Promise<void> {
  await Promise.all(
    [
      'supplier-invoices',
      'supplier-invoice',
      'supplier-credit-notes',
      'supplier-credit-note',
      'payable-balance',
      'bank-cash',
      'bank-movements',
      'bank-movement',
      'payments',
      'payment',
      'journals',
      'journal',
    ].map((key) => queryClient.invalidateQueries({ queryKey: [key], refetchType: 'all' })),
  );
}
